import React from 'react'
import GenericMutationModalBase from '../modal/GenericMutationModalBase'

const SelectPickListItemModal = ({
  bucket,
  setSelection,
  isModalOpen,
  setIsModalOpen,
  pickerEntityDisplayName,
  children
}) => {
  const cancelHandler = () => {
    setIsModalOpen(false)
  }

  const saveHandler = () => {
    const presaveProcessor = bucket.tempChanges.presaveProcessor
    const data = bucket.tempChanges.data

    if (data) {
      if (presaveProcessor) {
        setSelection(presaveProcessor(bucket.tempChanges.data))
      } else {
        setSelection(data)
      }
    } else {
      setSelection(bucket.selection)
    }

    setIsModalOpen(false)
  }

  return (
    <div>
      <GenericMutationModalBase
        header={`Assign ${pickerEntityDisplayName}`}
        saveHandler={saveHandler}
        cancelHandler={cancelHandler}
        open={isModalOpen}
        setOpen={setIsModalOpen}
      >
        {children}
      </GenericMutationModalBase>
    </div>
  )
}

export default React.memo(SelectPickListItemModal)
